import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Page from '../../components/Page';
import User from '../../components/User';
import config from '../../config';
import NavBar from './NavBar';
import ProfileRoutes from './ProfileRoutes';
import UserBasicInfo from '../../components/Profile/UserBasicInfo';
import { fetchRatings } from '../../redux/actions/ratingsActions';
import { appendHoneyGuide, isBrowser } from '../../lib/utils';
import { getUserById, updateUserData } from '../../redux/actions/userActions';

class Profile extends Component {
  componentDidMount() {
    this.props.fetchRatings();
  }

  getSEOTags(userData) {
    if (userData) {
      const { fullname, profile_images, about } = userData;

      return {
        title: fullname ? appendHoneyGuide(fullname) : '',
        image: profile_images ? `${config.RESOURCE_URL}/${profile_images.large}` : '',
        description: about ? about : '',
        noCrawl: true,
      };
    }
  }

  render() {
    const { ratings, urlUserId, loggedInUser, isViewingOwnProfile, reviews } = this.props;

    const noOfReviews = reviews && Object.keys(reviews).length;

    return (
      <User userId={urlUserId}>
        {({ userData }) => {
          return (
            <Page {...this.getSEOTags(userData)}>
              <div className="container">
                <div className="row no-gutters">
                  <UserBasicInfo
                    userData={userData}
                    userId={urlUserId}
                    ratings={ratings}
                    noOfReviews={noOfReviews}
                    isLeader={loggedInUser.isLeader}
                    isViewingOwnProfile={isViewingOwnProfile}
                  />
                </div>
                <div className="row mt-3">
                  <div className="col-md-3 col-12">
                    <div className="white-panel">
                      <NavBar isViewingOwnProfile={isViewingOwnProfile} />
                      {userData.is_leader && !isViewingOwnProfile && (
                        <Fragment>
                          <ul className="user-profile-list side">
                            {certicationKeys.map(item => {
                              // const isVerified = userData[item.key] ? userData[item.key].is_verified : false;
                              const isVerified = true;
                              return (
                                <li key={item.key}>
                                  <i
                                    className={`icon icon-hg-${
                                      isVerified ? 'check' : 'cross'
                                    }-circle ${isVerified ? 'verified' : ' '}`}
                                  />
                                  <span>{item.title}</span>
                                </li>
                              );
                            })}
                          </ul>
                        </Fragment>
                      )}
                    </div>
                  </div>
                  {isBrowser() && (
                    <div className="col-md-9 col-12">
                      <div className="white-panel basic-pannel">
                        <ProfileRoutes {...this.props} userData={userData} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Page>
          );
        }}
      </User>
    );
  }
}

const certicationKeys = [
  {
    title: 'Certified Guide',
    key: 'guide_certificate',
    subKey: 'issued_on',
  },
  {
    title: 'Verified Email Address',
    key: 'contact_email',
    subKey: 'email_address',
  },
  {
    title: 'Verified Phone Number',
    key: 'contact_phone',
    subKey: 'phone_number',
  },
  {
    title: 'Government Issued ID',
    key: 'goverment_issued_id',
    subKey: 'issued_on',
  },
];

const mapStateToProps = (
  { user, schema, ratingsState: { ratings }, reviewsState: { reviews } },
  ownProps
) => {
  const loggedInUserId = user.userId;
  const urlUserId = ownProps.match.params.userId;
  const ownData = schema.users.byId[urlUserId];

  return {
    loggedInUser: {
      id: loggedInUserId,
      name: user.name,
      role: user.role,
      image: user.image,
      connectedLodge: user.connectedLodge,
      isLeader: user.isLeader,
    },
    isViewingOwnProfile: urlUserId === loggedInUserId,
    urlUserId,
    ratings,
    reviews,
    userData: ownData,
  };
};

const origin = 'profile';

const mapDispatchToProps = dispatch => ({
  getLoggedInUserData: async id => await dispatch(getUserById(id)),
  fetchRatings: () => dispatch(fetchRatings(origin)),
  updateUserData: userData => dispatch(updateUserData(userData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/screens/Profile/Profile.jsx